import {SoundSpriteDefinitions} from 'howler';

export const musicSprites: SoundSpriteDefinitions = {
    "bonus-game": [
        0,
        25584.557823129253,
        true
    ],
    "level-complete": [
        27000,
        24008.775510204083,
        true
    ],
    "level": [
        53000,
        29994.60317460317,
        true
    ],
    "main-menu": [
        84000,
        57541.564625850355,
        true
    ]
};